import { createSharedPathnamesNavigation } from "next-intl/navigation";
import { LOCALES, localePrefix } from "./i18n";

export const { Link, redirect, usePathname, useRouter } =
  createSharedPathnamesNavigation({
    locales: LOCALES,
    localePrefix: localePrefix
  });
